module.exports = require('./lib/input-moment');



/*****************
 ** WEBPACK FOOTER
 ** ./~/input-moment/index.js
 ** module id = 1197
 ** module chunks = 0
 **/